<template>
  <router-view />
  <global-dialog />
</template>
